import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDescribeError } from '../i18n/useDescribeError';

export function LoadingBlock({ label }: { label?: string }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 3 }}>
      <CircularProgress size={22} />
      <Typography color="text.secondary">{label ?? t('states.loading')}</Typography>
    </Box>
  );
}

export function ErrorBlock({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const describe = useDescribeError();

  return (
    <Alert
      severity="error"
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            {t('actions.retry')}
          </Button>
        ) : undefined
      }
    >
      {describe(error)}
    </Alert>
  );
}

export function EmptyBlock({ message }: { message: string }) {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}

/** Fills a data grid's row area, which supplies its own height, rather than adding to the flow. */
export function GridEmptyOverlay({ message }: { message: string }) {
  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Typography color="text.secondary" textAlign="center">
        {message}
      </Typography>
    </Box>
  );
}
